'use client';
import { useEffect, useState } from 'react';
import { TableHeadlinePowerPlay, TablePrimaryHeader, TablesSwitcher } from '..';
import { ResultsTable } from '../../../ResultsTable/ResultsTable';
import { usePrizeTablesContext } from '../../context';

/**
 * PrizeTablesWithSwitchButtons component renders a set of prize tables with switch buttons.
 * Manages state, to render correct table when selected.
 * When selected table is not the main lottery, it renders a headline with power play information.
 */
function PrizeTablesWithSwitchButtons() {
  const { lotteryName, namespace, tables, className } = usePrizeTablesContext();
  const [selectedTable, setSelectedTable] = useState(tables[0]!);
  const { lotteryId: selectedId, data } = selectedTable;

  useEffect(() => {
    setSelectedTable(tables[0]!);
  }, [tables]);

  return (
    <div className={className}>
      <TablePrimaryHeader namespace={namespace} />
      <TablesSwitcher selectedId={selectedId} setSelectedTable={setSelectedTable} />
      {selectedId !== lotteryName ? <TableHeadlinePowerPlay selectedId={selectedId!} /> : null}
      <ResultsTable data={data} disableFirstRow={selectedId !== lotteryName} />
    </div>
  );
}

export { PrizeTablesWithSwitchButtons };
